/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FieldGeneratorOutputType = {
    Source: 'Source',
    Static: 'Static',
    Script: 'Script'
} as const;
export type FieldGeneratorOutputType = typeof FieldGeneratorOutputType[keyof typeof FieldGeneratorOutputType];


export function FieldGeneratorOutputTypeFromJSON(json: any): FieldGeneratorOutputType {
    return FieldGeneratorOutputTypeFromJSONTyped(json, false);
}

export function FieldGeneratorOutputTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FieldGeneratorOutputType {
    return json as FieldGeneratorOutputType;
}

export function FieldGeneratorOutputTypeToJSON(value?: FieldGeneratorOutputType | null): any {
    return value as any;
}

